import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const PrintIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M5.79995 9.80005C5.46858 9.80005 5.19995 10.0687 5.19995 10.4C5.19995 10.7314 5.46858 11 5.79995 11H7.39996C7.73133 11 7.99996 10.7314 7.99996 10.4C7.99996 10.0687 7.73133 9.80005 7.39996 9.80005H5.79995Z"
				fill="#4C4C58"
			/>
			<path
				d="M9.19998 14.4C8.8686 14.4 8.59998 14.6687 8.59998 15C8.59998 15.3314 8.8686 15.6 9.19998 15.6H14.8C15.1313 15.6 15.4 15.3314 15.4 15C15.4 14.6687 15.1313 14.4 14.8 14.4H9.19998Z"
				fill="#4C4C58"
			/>
			<path
				d="M8.59998 17.2C8.59998 16.8687 8.8686 16.6 9.19998 16.6H13.2C13.5313 16.6 13.8 16.8687 13.8 17.2C13.8 17.5314 13.5313 17.8 13.2 17.8H9.19998C8.8686 17.8 8.59998 17.5314 8.59998 17.2Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.39996 5.6C6.39996 4.16406 7.56402 3 8.99996 3H15C16.4359 3 17.6 4.16406 17.6 5.6V7.40002H18.4C19.8359 7.40002 21 8.56408 21 10V14C21 15.436 19.8359 16.6 18.4 16.6H17.6V19.4C17.6 20.2837 16.8836 21 16 21H7.99996C7.11631 21 6.39996 20.2837 6.39996 19.4V16.6H5.6C4.16406 16.6 3 15.436 3 14V10C3 8.56408 4.16406 7.40002 5.6 7.40002H6.39996V5.6ZM6.39996 15.4V13.8C6.39996 12.9164 7.11631 12.2 7.99996 12.2H16C16.8836 12.2 17.6 12.9164 17.6 13.8V15.4H18.4C19.1732 15.4 19.8 14.7732 19.8 14V10C19.8 9.22683 19.1732 8.60002 18.4 8.60002H5.6C4.8268 8.60002 4.2 9.22683 4.2 10V14C4.2 14.7732 4.8268 15.4 5.6 15.4H6.39996ZM16.4 5.6V7.40002H7.59996V5.6C7.59996 4.8268 8.22676 4.2 8.99996 4.2H15C15.7732 4.2 16.4 4.8268 16.4 5.6ZM7.59996 13.8C7.59996 13.5791 7.77905 13.4 7.99996 13.4H16C16.2209 13.4 16.4 13.5791 16.4 13.8V19.4C16.4 19.6209 16.2209 19.8 16 19.8H7.99996C7.77905 19.8 7.59996 19.6209 7.59996 19.4V13.8Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

PrintIcon.propTypes = iconPropTypes;
PrintIcon.defaultProps = iconDefaultProps;
